import { Alert, Stack } from '@mui/material'
import HeatStressOverview from './heatStress/HeatStressOverview'
import HeatStressTrends from './heatStress/HeatStressTrends'

const PropertyHeatStress: React.FC<any> = ({ propertyId, emissionTier }) => {
  if (!propertyId) {
    return <Alert severity="info">Select a property to view heat stress metrics.</Alert>
  }

  return (
    <Stack spacing={4}>
      <HeatStressOverview propertyId={propertyId} emissionTier={emissionTier} />
      <HeatStressTrends propertyId={propertyId} emissionTier={emissionTier} />
    </Stack>
  )
}

export default PropertyHeatStress
